import { ArrowPosition } from "../StickyNote";
import { AnchorIds, TourIds, TourSignal } from "../TourTypes";

export const SERIES_FOLDER_INTRO_TOUR = {
  id: TourIds.SERIES_FOLDER_INTRO,
  steps: [
    {
      id: "1",
      stickies: [
        {
          content: (
            <p>
              Projects inside a <strong>Series Folder</strong> share Story Bible characters, worldbuilding, and
              outlines.
            </p>
          ),
          offsetX: 0,
          offsetY: -400,
          anchorId: AnchorIds.SERIES_FOLDER_PROJECTS_AREA,
          arrowPosition: ArrowPosition.BottomLeft,
          rotation: 2,
        },
        {
          content: (
            <p>
              👈 Try importing a project to set up a Story Bible automatically.
            </p>
          ),
          offsetX: 150,
          offsetY: 0,
          anchorId: AnchorIds.NEW_PROJECT_BUTTON,
          rotation: -2,
        },
      ],
      listeningFor: [TourSignal.NEW_PROJECT_BUTTON_CLICKED],
    },
  ],
};
